import React from "react";
import Switch from "@material-ui/core/Switch";
import { withStyles } from "@material-ui/core/styles";
import { Box } from "@material-ui/core";
export const CustomSwitch = withStyles((theme) => ({
  root: {
    width: 36,
    height: 22,
    padding: 0,
    // marginTop: 6,
    margin: "6px 0px",
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#16191f",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#52d869",
      border: "6px solid #fff",
    },
  },
  disabled: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "grey",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#52d869",
      border: "6px solid #fff",
    },
  },
  thumb: {
    width: 20,
    height: 20,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    // backgroundColor: theme.palette.grey[50],
    backgroundColor: "grey",
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
  label: {
    fontSize: 14,
    fontWeight: 600,
  },
}))(({ classes, label, isFlex, isReverse, isIcon, icon, ...props }) => {
  return (
    <Box
      style={
        isFlex
          ? {
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "10px",
            }
          : { display: "flex", flexDirection: "column" }
      }
    >
      {isReverse !== true && label && (
        <label className={classes.label}>{label}</label>
      )}
      {isIcon && icon}
      <Switch
        focusVisibleClassName={classes.focusVisible}
        disableRipple
        classes={{
          root: classes.root,
          switchBase: classes.switchBase,
          thumb: classes.thumb,
          track: classes.track,
          checked: classes.checked,
          disabled: classes.disabled,
        }}
        {...props}
      />
      {isReverse === true && <label className={classes.label}>{label}</label>}
    </Box>
  );
});

export default CustomSwitch;
